import { ArrowUpRight, CalendarCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "../../config/site";

export const CTABanner = () => (
  <section className="grain relative overflow-hidden bg-navy py-24 sm:py-28" data-testid="cta-banner-section">
    <div className="pointer-events-none absolute left-[12%] top-[-40%] h-[420px] w-[420px] rounded-full bg-gold/[0.13] blur-[110px]" />
    <div className="pointer-events-none absolute bottom-[-45%] right-[8%] h-[420px] w-[420px] rounded-full bg-magenta/[0.12] blur-[110px]" />
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

    <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-gold-light">Start a project</p>
        <h2 className="mt-5 font-jakarta text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="cta-banner-heading">
          Have an Idea? <span className="gradient-brand">Let's Build It.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl font-inter text-[15px] leading-relaxed text-slate-400">
          Whether you need a website, mobile application, SaaS platform, ERP system or a complete digital
          transformation solution, RCS can help turn your idea into a working digital product.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection("#contact")}
            data-testid="cta-start-project-button"
            className="group inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 font-jakarta text-sm font-semibold text-navy transition-colors duration-300 hover:bg-gold-light"
          >
            Start Your Project
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </button>
          <button
            onClick={() => scrollToSection("#contact")}
            data-testid="cta-book-consultation-button"
            className="inline-flex items-center gap-2.5 rounded-full border border-white/20 px-8 py-4 font-jakarta text-sm font-semibold text-white transition-colors duration-300 hover:border-magenta hover:text-magenta"
          >
            <CalendarCheck className="h-4 w-4" />
            Book a Free Consultation
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
